// src/helpers/notificationHelper.js
import React from 'react';
import { 
  Plus, FileText, Clock, AlertTriangle, Bell, 
  CheckCircle2, Calendar, CreditCard, UserPlus, X 
} from 'lucide-react';

/**
 * Centrally resolves and returns the correct React icon based on notification type.
 * Edit this single file to add icons for any new modules in the future [1]!
 * 
 * @param {string} type 
 * @returns {React.Component} Lucide Icon component
 */
export const getNotificationIcon = (type) => {
  switch (type) {
    // --- POLICIES AND LETTERS MODULE ---
    case 'new_policy': 
      return <Plus className="h-4 w-4 text-blue-500" />;
    case 'policy_updated': 
      return <FileText className="h-4 w-4 text-green-500" />;
    case 'ack_reminder': 
      return <Clock className="h-4 w-4 text-yellow-500" />;
    case 'policy_expiring': 
      return <AlertTriangle className="h-4 w-4 text-red-500" />;

    // --- KRA / GOAL PERFORMANCE MODULE ---
    case 'kra_assigned': 
      return <CheckCircle2 className="h-4 w-4 text-indigo-500" />;
    case 'kra_review_pending': 
      return <Clock className="h-4 w-4 text-purple-500" />;

    // --- LEAVES & ATTENDANCE MODULE ---
    case 'leave_approved': 
      return <Calendar className="h-4 w-4 text-green-500" />;
    case 'leave_rejected': 
      return <X className="h-4 w-4 text-red-500" />;
    case 'attendance_regularization': 
      return <Clock className="h-4 w-4 text-orange-400" />;

    // --- PAYROLL MODULE ---
    case 'payslip_released': 
      return <CreditCard className="h-4 w-4 text-emerald-500" />;

    // --- ONBOARDING MODULE ---
    case 'onboarding_task_assigned': 
      return <UserPlus className="h-4 w-4 text-sky-500" />;

    default: 
      return <Bell className="h-4 w-4 text-gray-500" />;
  }
};

/**
 * Centrally resolves and returns the correct redirect path based on notification type.
 * Edit this single file to add routes for any new modules in the future [1]!
 * 
 * @param {Object} item Notification object
 * @param {string} portalName Active portal subpath
 * @returns {string} Target navigation URL path
 */
export const getNotificationRoute = (item, portalName) => {
  // If the notification belongs to Policies or Letters
  if (item.policyDocumentId) {
    const docId = item.policyDocumentId?._id || item.policyDocumentId;
    return `/${portalName}/hr/letter-policy/my-policies/${docId}`;
  }

  // Handle other module redirections dynamically
  switch (item.type) {
    case 'kra_assigned':
      return `/${portalName}/hr/performance-management`;
    case 'kra_review_pending':
      return `/${portalName}/hr/kra/review-list`;
    case 'leave_approved':
    case 'leave_rejected':
      return `/${portalName}/my/leaves`;
    case 'payslip_released':
      return `/${portalName}/my/payroll/payslips`;
    case 'onboarding_task_assigned':
      return `/${portalName}/onboarding/my-tasks`;
    default:
      return `/${portalName}/home`;
  }
};